
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const UserRoleEnum = {
  USER: 'USER',
  ADMIN: 'ADMIN'
} as const

export type UserRoleEnum = (typeof UserRoleEnum)[keyof typeof UserRoleEnum]


export const RegionStatus = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  DEACTIVATED: 'DEACTIVATED'
} as const

export type RegionStatus = (typeof RegionStatus)[keyof typeof RegionStatus]


export const RegionProduct = {
  radverkehr: 'radverkehr',
  parkraum: 'parkraum',
  fussverkehr: 'fussverkehr',
  analysis: 'analysis'
} as const

export type RegionProduct = (typeof RegionProduct)[keyof typeof RegionProduct]


export const RegionContractStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
} as const

export type RegionContractStatus = (typeof RegionContractStatus)[keyof typeof RegionContractStatus]


export const MapDatasetUploadCreatedBy = {
  USER: 'USER',
  SCRIPT: 'SCRIPT'
} as const

export type MapDatasetUploadCreatedBy = (typeof MapDatasetUploadCreatedBy)[keyof typeof MapDatasetUploadCreatedBy]


export const MapRenderFormatEnum = {
  pmtiles: 'pmtiles',
  geojson: 'geojson'
} as const

export type MapRenderFormatEnum = (typeof MapRenderFormatEnum)[keyof typeof MapRenderFormatEnum]


export const ReviewEntryGeometryType = {
  POINT: 'POINT',
  LINESTRING: 'LINESTRING',
  POLYGON: 'POLYGON',
  MULTIPOINT: 'MULTIPOINT',
  MULTILINESTRING: 'MULTILINESTRING',
  MULTIPOLYGON: 'MULTIPOLYGON'
} as const

export type ReviewEntryGeometryType = (typeof ReviewEntryGeometryType)[keyof typeof ReviewEntryGeometryType]


export const ReviewEntrySource = {
  UPLOAD: 'UPLOAD',
  MANUAL: 'MANUAL'
} as const

export type ReviewEntrySource = (typeof ReviewEntrySource)[keyof typeof ReviewEntrySource]


export const ReviewEntryStatus = {
  OPEN: 'OPEN',
  OK: 'OK',
  PROBLEM: 'PROBLEM'
} as const

export type ReviewEntryStatus = (typeof ReviewEntryStatus)[keyof typeof ReviewEntryStatus]


export const QaAreaFilter = {
  all: 'all',
  priority: 'priority',
  non_priority: 'non_priority',
  with_reference: 'with_reference'
} as const

export type QaAreaFilter = (typeof QaAreaFilter)[keyof typeof QaAreaFilter]


export const QaSystemStatus = {
  GOOD: 'GOOD',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
  PROBLEMATIC: 'PROBLEMATIC',
  TRUSTED_EDITOR_CHANGE: 'TRUSTED_EDITOR_CHANGE'
} as const

export type QaSystemStatus = (typeof QaSystemStatus)[keyof typeof QaSystemStatus]


export const QaEvaluationStatus = {
  OK_STRUCTURAL_CHANGE: 'OK_STRUCTURAL_CHANGE',
  OK_REFERENCE_ERROR: 'OK_REFERENCE_ERROR',
  NOT_OK_DATA_ERROR: 'NOT_OK_DATA_ERROR',
  NOT_OK_PROCESSING_ERROR: 'NOT_OK_PROCESSING_ERROR',
  OK_QA_TOOLING_ERROR: 'OK_QA_TOOLING_ERROR'
} as const

export type QaEvaluationStatus = (typeof QaEvaluationStatus)[keyof typeof QaEvaluationStatus]


export const QaEvaluatorType = {
  SYSTEM: 'SYSTEM',
  USER: 'USER'
} as const

export type QaEvaluatorType = (typeof QaEvaluatorType)[keyof typeof QaEvaluatorType]


export const DataSchemaImportStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
} as const

export type DataSchemaImportStatus = (typeof DataSchemaImportStatus)[keyof typeof DataSchemaImportStatus]
